// ==============================================
// File: src/lib/env.js
// Vite env accessors with sane fallbacks + validation
// Usage:
//   import { ENV, readEnv } from "@/lib/env";
//   ENV.ESCROW_URL
//   readEnv("VITE_SUPABASE_URL", { required: true })
// ==============================================

/** Safe reader for import.meta.env with defaults + required flag */
export function readEnv(key, opts = {}) {
  const { required = false, fallback = "" } = opts;
  const v = import.meta?.env?.[key];
  if (v === undefined || v === null || v === "") {
    if (required) {
      // Make it loud in dev; avoid throwing in production runtime
      if (import.meta.env.DEV) {
        // eslint-disable-next-line no-console
        console.warn(`[env] Missing required ${key}`);
      }
    }
    return fallback;
  }
  return v;
}

export const ENV = Object.freeze({
  MODE: readEnv("MODE", { fallback: "production" }),
  DEV: !!import.meta.env.DEV,
  PROD: !!import.meta.env.PROD,
  APP_BASE_URL: readEnv("VITE_APP_BASE_URL", { fallback: "" }),

  // App URLs / API endpoints
  ESCROW_URL: readEnv("VITE_ESCROW_URL", { fallback: "" }),

  // Supabase
  SUPABASE_URL: readEnv("VITE_SUPABASE_URL", { fallback: "" }),
  SUPABASE_ANON: readEnv("VITE_SUPABASE_ANON_KEY", { fallback: "" }),

  // Google Drive
  GOOGLE_CLIENT_ID: readEnv("VITE_GOOGLE_CLIENT_ID", { fallback: "" }),

  // Feature toggles / debug
  DRIVE_DEBUG: String(readEnv("VITE_DRIVE_DEBUG", { fallback: "false" })).toLowerCase() === "true",
});

export const ESCROW_URL = ENV.ESCROW_URL; // backwards compatibility
export const APP_BASE_URL =
  (typeof window !== "undefined" && ENV.APP_BASE_URL) ||
  (typeof window !== "undefined" ? window.location.origin : "");
